<div
  class="search__box"
  (clickOutside)="onClickOutSide()"
>
  <div class="search__container d-flex flex-column">
    <div class="w-100 position-relative">
      <span class="search__icon-wrapper">
        @if (
          selectedOrg &&
          selectedOrgDisplayed() &&
          (selectedOrg.logo?.url || selectedOrg.logo)
        ) {
          <span
            class="search__selected-logo"
            [ngStyle]="{
              'background-image':
                'url(' + (selectedOrg.logo?.url || selectedOrg.logo) + ')',
            }"
            [attr.aria-label]="selectedOrg.orgName || selectedOrg.name"
          ></span>
        } @else {
          @if (isSearching) {
            <span
              class="spinner-border spinner-border-sm search__icon"
              aria-hidden="true"
            ></span>
          } @else {
            <ng-icon
              name="matSearchOutline"
              class="search__icon"
            ></ng-icon>
          }
        }
      </span>

      <input
        #searchInput
        #searchInputModel="ngModel"
        id="search"
        type="text"
        class="search__input form-control form-controls-sm"
        [(ngModel)]="searchText"
        (ngModelChange)="onChangeSearchText()"
        [placeholder]="searchPlaceholder || 'Label.SearchName' | translate"
        (focus)="onFocusSearchInput()"
        (blur)="onBlurSearchInput()"
        (click)="onClickSearchInput()"
        autocomplete="off"
        [disabled]="disabled()"
      />

      @if (isDropdownOpen && virtualScrollItems.length > 0) {
        <div class="dropdown-menu show">
          <virtual-scroller
            #scroll
            class="align-self-start"
            [ngClass]="resultContainer"
            [bufferAmount]="3"
            [enableUnequalChildrenSizes]="true"
            [items]="virtualScrollItems"
            (vsEnd)="loadMore($event)"
            [style.height]="enableDynamicHeight ? getDynamicHeight() : height"
          >
            @for (result of scroll.viewPortItems; track $index) {
              <button
                class="dropdown-item"
                (click)="onSelectOrg(result)"
              >
                @if (
                  result.tagFieldType === orgsSearchTagFieldTypeEnum.Header
                ) {
                  <div class="search-result">
                    <span>{{ 'Suggestions' | translate }}</span>
                  </div>
                }

                @if (!result.tagFieldType) {
                  <div class="search-result">
                    <div
                      class="search-result__logo"
                      [ngStyle]="{
                        'background-image':
                          'url(' + (result.logo?.url || result.logo) + ')',
                      }"
                    ></div>

                    <div class="search-result__name truncate-line-1">
                      <ngb-highlight
                        class="truncate-line-1"
                        [result]="result.name || result.orgName"
                        [term]="searchText"
                      ></ngb-highlight>
                    </div>

                    @if (result.isMyOrganisation) {
                      <div class="search-result__badge">
                        <span translate>My Organization</span>
                      </div>
                    }
                  </div>
                }
              </button>
            }

            @if (isSearching) {
              <div class="w-100 text-center">
                <span
                  class="spinner-border spinner-border-sm"
                  aria-hidden="true"
                ></span>
              </div>
            }
          </virtual-scroller>

          @if (createNewOrgEnabled()) {
            <div class="border-top p-3">
              <button
                class="text-medium-gray d-flex align-items-center btn-unstyled"
                (click)="openCreateNewOrgSection()"
              >
                <ng-icon
                  name="matAddCircleOutline"
                  class="font-size-xl me-2"
                ></ng-icon>

                {{ 'SimpleOrgCreation.CreateNewOrgBtn.Label' | translate }}
              </button>
            </div>
          }

          <ng-content></ng-content>
        </div>
      }

      <span
        class="search__icon-wrapper search__icon-wrapper--last pointer-cursor"
      >
        @if (
          (this.searchText || (selectedOrg && selectedOrgDisplayed())) &&
          !disabled()
        ) {
          <ng-icon
            name="matCloseOutline"
            class="reset-search"
            appDebounceClick
            (debounceClick)="resetSearchText()"
            focusable="false"
          ></ng-icon>
        }
      </span>
    </div>
  </div>
</div>
